// extracted by mini-css-extract-plugin
export var base = "_1b-0";
export var updateBanner = "_1b-1";